import * as z from 'zod';

export const BUG_REPORT_CATEGORIES = [
  'bug',
  'incorrect_content',
  'feature_request',
  'other',
] as const;

export type BugReportCategory = (typeof BUG_REPORT_CATEGORIES)[number];

export const BUG_REPORT_CATEGORY_LABELS: Record<BugReportCategory, string> = {
  bug: 'Bug',
  incorrect_content: 'Incorrect content',
  feature_request: 'Feature request',
  other: 'Other',
};

export const MAX_SCREENSHOTS = 5;
export const MAX_SCREENSHOT_BYTES = 1 * 1024 * 1024; // 1 MB per file
const ALLOWED_SCREENSHOT_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
];

const fileArraySchema = z
  .array(z.instanceof(File))
  .min(1, 'Please attach at least one screenshot')
  .max(MAX_SCREENSHOTS, `Up to ${MAX_SCREENSHOTS} screenshots allowed`)
  .refine(
    files => files.every(f => f.size <= MAX_SCREENSHOT_BYTES),
    'Each screenshot must be 1 MB or smaller'
  )
  .refine(
    files => files.every(f => ALLOWED_SCREENSHOT_TYPES.includes(f.type)),
    'Screenshots must be PNG, JPEG, WebP, or GIF'
  );

export const bugReportSchema = z.object({
  category: z.enum(BUG_REPORT_CATEGORIES),
  title: z
    .string()
    .trim()
    .min(3, 'Add a short title (3+ characters)')
    .max(200, 'Title must be at most 200 characters'),
  description: z
    .string()
    .trim()
    .min(10, 'Please describe what happened (10+ characters)')
    .max(5000, 'Description must be at most 5000 characters'),
  screenshots: fileArraySchema,
});

export type BugReportForm = z.infer<typeof bugReportSchema>;
